import { render, staticRenderFns } from "./CodeEqual2.vue?vue&type=template&id=321cfbf0"
import script from "./CodeEqual2.vue?vue&type=script&lang=js"
export * from "./CodeEqual2.vue?vue&type=script&lang=js"
import style0 from "./CodeEqual2.vue?vue&type=style&index=0&id=321cfbf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports